import {DomainEvent} from './DomainEvent';
import {MatchDistrictRelation} from '../resources/MatchDistrictRelation';

/**
 * Base class for events that indicate changes in match district relations.
 */
export abstract class MatchDistrictRelationEvent extends DomainEvent<MatchDistrictRelation> {}
